document.addEventListener('DOMContentLoaded', function() {
  const collectionListFullscreen = document.querySelector('.collection-list-fullscreen');
  if (!collectionListFullscreen) return;

  const nav = collectionListFullscreen.querySelector('.collection-nav');
  const navLinks = collectionListFullscreen.querySelectorAll('.collection-nav__link');
  const sections = collectionListFullscreen.querySelectorAll('.collection-section');

  // Force autoplay on videos
  const videos = collectionListFullscreen.querySelectorAll('.collection-section__video');
  videos.forEach(video => {
    video.play().catch(error => {
      console.log('Autoplay prevented:', error);
    });
  });
  
  // Track click states for each link
  const clickStates = new Map();
  
  // Handle scroll-based pinning
  let isScrolling;

  function updateNavPosition() {
    if (sections.length === 0) return;

    const firstSection = sections[0];
    const lastSection = sections[sections.length - 1];
    const viewportCenter = window.innerHeight / 2;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // Get positions
    const firstSectionRect = firstSection.getBoundingClientRect();
    const lastSectionRect = lastSection.getBoundingClientRect();

    // Calculate center positions relative to viewport
    const firstSectionCenter = firstSectionRect.top + (firstSectionRect.height / 2);
    const lastSectionCenter = lastSectionRect.top + (lastSectionRect.height / 2);

    // Start pinning when first section's center reaches viewport center
    // Stop pinning when last section's center reaches viewport center

    if (firstSectionCenter > viewportCenter) {
      // Before pinning zone - nav stays with first section
      nav.classList.remove('is-pinned');
      nav.classList.add('is-before-pin');
      nav.classList.remove('is-after-pin');
    } else if (lastSectionCenter < viewportCenter) {
      // After pinning zone - nav stays with last section
      nav.classList.remove('is-pinned');
      nav.classList.remove('is-before-pin');
      nav.classList.add('is-after-pin');
    } else {
      // Pinning zone - nav is fixed in center
      nav.classList.add('is-pinned');
      nav.classList.remove('is-before-pin');
      nav.classList.remove('is-after-pin');
    }
  }

  // Update on scroll with debouncing for better performance
  window.addEventListener('scroll', function() {
    window.clearTimeout(isScrolling);
    updateNavPosition();

    isScrolling = setTimeout(function() {
      updateNavPosition();
    }, 66);
  }, { passive: true });

  // Update on resize
  window.addEventListener('resize', updateNavPosition);

  // Initial update
  updateNavPosition();

  // Observer to hide nav when scrolling outside the container
  const visibilityObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        nav.style.display = '';
      } else {
        nav.style.display = 'none';
      }
    });
  }, {
    root: null,
    threshold: 0
  });

  // Observe the entire collection list container
  visibilityObserver.observe(collectionListFullscreen);
  
  // Smooth scroll to section
  function scrollToSection(sectionId) {
    const section = document.getElementById(`collection-${sectionId}`);
    if (section) {
      section.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'start' 
      });
    }
  }
  
  // Handle navigation clicks
  navLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      
      const collectionId = this.dataset.collectionId;
      const url = this.href;
      
      // Check if this link has been clicked before
      if (clickStates.get(collectionId)) {
        // Second click - navigate to collection
        window.location.href = url;
      } else {
        // First click - scroll to section
        clickStates.set(collectionId, true);
        this.classList.add('clicked-once');
        scrollToSection(collectionId);
        
        // Reset click state after 3 seconds
        setTimeout(() => {
          clickStates.delete(collectionId);
          this.classList.remove('clicked-once');
        }, 3000);
      }
    });
  });
  
  // Intersection Observer for active states
  const observerOptions = {
    root: null,
    rootMargin: '-45% 0px -45% 0px',
    threshold: 0
  };
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const collectionId = entry.target.dataset.collectionId;
        
        // Update active nav link
        navLinks.forEach(link => {
          if (link.dataset.collectionId === collectionId) {
            link.classList.add('active');
          } else {
            link.classList.remove('active');
          }
        });
      }
    });
  }, observerOptions);
  
  // Observe all sections
  sections.forEach(section => {
    observer.observe(section);
  });
  
  // Handle direct section links
  const sectionLinks = collectionListFullscreen.querySelectorAll('.collection-section__link');
  sectionLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      // If nav is clicked once for this collection, navigate immediately
      const collectionId = this.closest('.collection-section').dataset.collectionId;
      if (clickStates.get(collectionId)) {
        return; // Let default behavior happen
      }
    });
  });
  
  // Add keyboard navigation
  document.addEventListener('keydown', function(e) {
    if (!collectionListFullscreen.contains(document.activeElement)) return;
    
    let currentIndex = -1;
    const activeSection = document.querySelector('.collection-section:hover') || 
                         document.querySelector('.collection-nav__link.active');
    
    if (activeSection) {
      const activeId = activeSection.dataset.collectionId || 
                      activeSection.closest('.collection-section')?.dataset.collectionId;
      navLinks.forEach((link, index) => {
        if (link.dataset.collectionId === activeId) {
          currentIndex = index;
        }
      });
    }
    
    switch(e.key) {
      case 'ArrowDown':
        e.preventDefault();
        if (currentIndex < navLinks.length - 1) {
          navLinks[currentIndex + 1].click();
        }
        break;
      case 'ArrowUp':
        e.preventDefault();
        if (currentIndex > 0) {
          navLinks[currentIndex - 1].click();
        }
        break;
    }
  });
});